import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SettlePaymentHotelSummary from './SettlePaymentHotelSummary';
import PaymentMethodGroup from './PaymentMethod/PaymentMethodGroup.react';
import { Button } from '@mui/material';
import { PAYMENT_TYPE } from './const';
import PaymentSummary from './PaymentMethod/PaymentSummary.react';
import Analytics from 'arbitrip-common/client/analytics';
import helpers from './helpers';

const SettlePaymentPaymentMethod = ({ profile, booking, bookings, isMultiMode, method, setMethod, chargeCurrency, onNext }) => {
	const { t } = useTranslation();

	useEffect(() => {
		if (isMultiMode && method !== PAYMENT_TYPE.BANK_TRANSFER) {
			setMethod(PAYMENT_TYPE.BANK_TRANSFER);
		}
	}, [isMultiMode, method, setMethod]);

	return (
		<div className="settle-payment-wrap">
			<div className="settle-payment payment-method">
				<PaymentSummary
					profile={profile}
					booking={booking}
					bookings={bookings}
					isMultiMode={isMultiMode}
					chargeCurrency={chargeCurrency}
				/>

				<div className="payment-method__radio-wrap">
					<PaymentMethodGroup
						value={method}
						onChange={setMethod}
						booking={booking}
						profile={profile}
						isMultiMode={isMultiMode}
					/>
				</div>

				<div className="actions">
					<Button
						variant="contained"
						fullWidth
						onClick={() => {
							if (method === PAYMENT_TYPE.CREDIT_CARD) {
								const markup = helpers.getCommissionPercentage(booking);
								Analytics.actions.interactions.creditCardClicked({
									bookingId: booking.id,
									currency: chargeCurrency,
									payment_method: PAYMENT_TYPE.CREDIT_CARD,
									markup: `${markup}%`,
								});
							}

							onNext(method);
						}}
					>
						{t('Bookings.SettlePayment.Continue')}
					</Button>
				</div>
			</div>
			<SettlePaymentHotelSummary booking={booking} />
		</div>
	);
};

export default SettlePaymentPaymentMethod;
